module.exports = __webpack_public_path__ + "img/justine_wichmann_9.385f029b.jpg";